import React from "react";

const descriptionClasses = "pl-2.5";

const providerTitleClasses =
    "bg-table-header h-10 pt-2.5 pl-2.5 text-base font-normal leading-6";

const MedicalRecordDetails = ({ data }) => {
    if (!data || !data.medicalTypeName) return null;
    
    const { medicalTypeName, name, treatmentDates, diagnosis, objectFindings, causation, diagnoses } = data

    const renderHospital = () => (
        <>
            <p className={providerTitleClasses}><strong>Medical Provider Name:</strong> {name}</p>
            {treatmentDates?.map((t, i) => (
                <React.Fragment key={i}>
                    {t?.treatmentSummary?.map((summary, j) => (
                        <p key={j} className={descriptionClasses}>
                            <span>{j === 0 ? "Diagnoses:" : ""}</span> {summary?.diagnosis?.replace(/:/g, "")}
                        </p>
                    ))}
                </React.Fragment>
            ))}
        </>
    );

    const renderSurgeryCenter = () => (
        <>
            <p className={providerTitleClasses}><strong>Medical Provider Name:</strong> {name}</p>
            {treatmentDates?.map((t, i) => (
                <p key={i} className={descriptionClasses}>
                    <span>{i === 0 ? "Procedure Name:" : ""}</span> {t?.procedures}
                </p>
            ))}
        </>
    );

    const renderER = () => (
        <>
            <p className={providerTitleClasses}><strong>Medical Provider Name:</strong> {name}</p>
            {treatmentDates?.map((t, i) => (
                <React.Fragment key={i}>
                    <p><span>{i === 0 ? "Admit Date:" : ""}</span> {t?.admittedDate}</p>
                    {t?.diagnoses?.map((d, j) => (
                        <p key={j} className={descriptionClasses}>
                            <span>{j === 0 ? "Diagnoses:" : ""}</span> {d?.replace(/:/g, "")}
                        </p>
                    ))}
                </React.Fragment>
            ))}
        </>
    );

    const renderMRI = () => (
        <>
            <p className={providerTitleClasses}><strong>Medical Provider Name:</strong> {name}</p>
            {treatmentDates?.map((t, i) => (
                <React.Fragment key={i}>
                    {t?.findings?.map((f, j) => (
                        <p key={j} className={descriptionClasses}>
                            <span>{j === 0 ? "Findings:" : ""}</span> 
                             {f}
                        </p>
                    ))}
                </React.Fragment>
            ))}
        </>
    );

    const renderConsultation = () => (
        <>
            <p className={providerTitleClasses}><strong>Medical Provider Name:</strong> {name}</p>
            <p className={descriptionClasses}><span>Causation:</span> {causation}</p>
            {diagnoses?.map((d, j) => (
                <p key={j} className={descriptionClasses}>
                    <span>{j === 0 ? "Diagnoses:" : ""}</span> {d?.replace(/:/g, "")}
                </p>
            ))}
            {treatmentDates?.map((t, i) => (
                <React.Fragment key={i}>
                    {t?.PlanDiscussion?.map((plan, l) => (
                        <p key={l} className={descriptionClasses}>
                            <span>{l === 0 ? "Plan Discussion:" : ""}</span> {plan}
                        </p>
                    ))}
                </React.Fragment>
            ))}
        </>
    );

    const renderOther = () => (
        <>
            <p className={providerTitleClasses}><strong>Medical Provider Name:</strong> {name}</p>
            <p className={descriptionClasses}><strong>Objective:</strong> {objectFindings}</p>
            {diagnosis?.map((d, i) => (
                <React.Fragment key={i}>
                    {d?.values?.map((v, j) => (
                        <p key={`${i}-${j}`} className={descriptionClasses}>
                            <span>{j === 0 ? "Diagnoses:" : ""}</span> {v?.replace(/:/g, "")}
                        </p>
                    ))}
                </React.Fragment>
            ))}
        </>
    );

    switch (medicalTypeName) {
        case "Hospital":
            return renderHospital();
        case "Surgery Center Reports":
            return renderSurgeryCenter();
        case "ER":
            return renderER();
        case "MRI Other Imaging":
            return renderMRI();
        case "Consultation Reports":
            return renderConsultation();
        case "All Other Medical Records":
            return renderOther();
        default:
            return null;
    }
};

export default MedicalRecordDetails;